import { useQuery } from "@tanstack/react-query";
import axios from "axios";

const useEventInfo = (guID?: string) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["events", guID],
    queryFn: () => getData(guID),
    enabled: !!guID,
  });

  return { data, isLoading, error };
};

const getData = async (guID?: string) => {
  
  const response = await axios.get(`/events/${guID}`);
  return response.data;
};

export default useEventInfo;

